import { render, staticRenderFns } from "./WBUDEditorFactory.vue?vue&type=template&id=5c65dcaa&scoped=true&"
import script from "./WBUDEditorFactory.vue?vue&type=script&lang=js&"
export * from "./WBUDEditorFactory.vue?vue&type=script&lang=js&"
import style0 from "./WBUDEditorFactory.vue?vue&type=style&index=0&id=5c65dcaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c65dcaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VIcon})
